// Le mode « apporte ton ChatGPT » : ce que le serveur et l'appli partagent.

/** Qui écrit le récit d'un monde : Claude (offert par Veillée) ou le ChatGPT de la personne qui l'a créé. */
export type ConteurKind = "claude" | "chatgpt";

/** La page où l'on tape son code d'appareil : une constante, jamais une adresse reçue. */
export const CHATGPT_DEVICE_PAGE = "https://auth.openai.com/codex/device";

/** L'état de la connexion ChatGPT d'un monde, tel que le voit un joueur (les détails : l'hôte seulement). */
export interface ChatGptLinkView {
  state: "a_connecter" | "code" | "connecte" | "probleme";
  /** code à taper (hôte seulement) */
  userCode: string | null;
  expiresAt: number | null;
  /** e-mail du compte (hôte seulement) */
  account: string | null;
  model: string | null;
  problem: string | null;
}
